export default {"src":"/_next/static/media/property.d0b5dbd6.svg","height":95,"width":88,"blurWidth":0,"blurHeight":0};